import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Alert, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CompleteModalIcon from "../Assets/Images/CompleteModalIcon";
import TimeupIcon from "../Assets/Images/TimeupIcon";
import { DobComponent, FormInput } from "../Component";
import { Formik, Form, Field } from "formik";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { debounce } from "debounce";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { dataAction } from "../state";
import { saveMajor, searchCountries } from "../Services/Function";

export default function CompleteModal(props) {
  const [countryCode, setCountryCode] = useState("+965");
  const [ErrorPhone, setErrorPhone] = useState(false);
  const [nameErr, setnameErr] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date(2000, 10, 12));
  const [ErrorDob, setErrorDob] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState("");
  const [authSuccess, setAuthSuccess] = useState("");
  const [countries, setcountries] = useState([]);

  let history = useNavigate();
  const location = useLocation();
  let destination = location.state?.country;

  const dispatch = useDispatch();
  const { showMajorAnimation } = bindActionCreators(dataAction, dispatch);

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let utm_source = params.get("utm_source");
  let utm_content = params.get("utm_content");
  let utm_medium = params.get("utm_medium");
  let utm_campaign = params.get("utm_campaign");
  let utm_term = params.get("utm_term");

  const searchCountry = debounce(async (e) => {
    if (!e.target.value) {
      setcountries([]);
    } else {
      const res = await searchCountries({
        text: e.target.value,
        sortBy: "createdAt:desc",
        limit: 7,
      });
      setcountries(res?.results);
    }
  }, 500);

  const pickHighest = (obj, num = 1) => {
    const requiredObj = {};
    if (num > Object.keys(obj).length) return false;
    Object.keys(obj)
      .sort((a, b) => obj[b] - obj[a])
      .forEach((key, ind) => {
        if (ind < num) requiredObj[key] = obj[key];
      });
    return requiredObj;
  };

  let majors = Object.keys(pickHighest(props.data, 5));

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!values.name) {
      setnameErr(true);
      setSubmitting(false);
      setAuthError("Please enter your name");
      return;
    }

    if (!selectedDate) {
      setErrorDob(true);
      setSubmitting(false);
      setAuthError("Please enter your date of birth");
      return;
    }

    const formattedPhone = values.phoneNo.startsWith("+")
      ? values.phoneNo
      : `+${values.phoneNo.replace(/\D/g, "")}`;

    if (!formattedPhone || formattedPhone.length < 8) {
      setErrorPhone(true);
      setAuthError("Please enter a valid phone number");
      setSubmitting(false);
      return;
    }

    try {
      setLoading(true);
      setAuthError("");
      console.log("hgyftuhj", props.userData);
      await saveMajor({
        majors: majors,
        selectedAns: props.selectedQuestionArr
          .sort((a, b) => a.question - b.question)
          .map((x) => x.ans),
        name: values.name,
        timeTaken: "",
        phoneNo: formattedPhone.slice(countryCode.length),
        countryCode: countryCode,
        dob: selectedDate,
        createdAt: Date.now(),
        nationality: props.userData.selectedCountry.english_name,
        destination: props.userData.destination.en_name,
        degree: props.userData.degree.en_name,
        cgpa: props.userData.cgpa,
        previousSchool: props.userData.previousSchool,
        englishProficiency: props.userData.englishProficiency,
        source: utm_source,
        campaign: utm_medium,
        medium: utm_campaign,
        content: utm_content,
      });

      showMajorAnimation(true);
      await history(
        props.query ? `/test-results${props.query}` : "/test-results",
        {
          state: { data: majors, destination: destination },
        }
      );
      props.onHide();
    } catch (error) {
      console.error("Error submitting form:", error);
      setAuthError("An error occurred while saving data. Please try again.");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="complete-modal-body">
        <div className="text-center mb-4">
          {!props.timeEnd ? (
            <CompleteModalIcon className="mb-3" />
          ) : (
            <TimeupIcon className="mb-3" />
          )}
          <h4 className="complete-modal-header">لقد أنهيت اختبار التخصص</h4>
          <p className="complete-modal-subheader">
            يرجى إكمال البيانات التالية للحصول على النتيجة
          </p>
        </div>

        {authError && (
          <Alert variant="danger" className="text-right">
            {authError}
          </Alert>
        )}

        {authSuccess && (
          <Alert variant="success" className="text-right">
            {authSuccess}
          </Alert>
        )}

        <Formik
          initialValues={{
            name: "",
            phoneNo: "",
          }}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, isSubmitting, setFieldValue }) => (
            <Form>
              <div className="mb-3">
                <Field name="name">
                  {({ field }) => (
                    <FormInput
                      noLabel
                      placeholder="الاسم الثلاثي (بالانجليزي)"
                      {...field}
                      onChange={(e) => {
                        handleChange(e);
                        setnameErr(false);
                        setAuthError("");
                      }}
                      type="text"
                      className="form-control-lg"
                      style={{
                        borderRadius: "50px",
                        backgroundColor: "rgba(217, 217, 217, 0.30)",
                        borderColor: nameErr ? "rgb(253, 62, 96)" : "#eae9f2",
                      }}
                    />
                  )}
                </Field>
                {nameErr && <div style={style.error}> الرجاء إدخال اسم</div>}
              </div>

              <div className="mb-3">
                <PhoneInput
                  international={false}
                  defaultCountry="KW"
                  placeholder="رقم الهاتف"
                  value={values.phoneNo}
                  onChange={(value) => {
                    setFieldValue("phoneNo", value);
                    setErrorPhone(false);
                    setAuthError("");
                  }}
                  disabled={loading}
                  className="form-control-lg"
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "rgba(217, 217, 217, 0.30)",
                    borderColor: ErrorPhone ? "rgb(253, 62, 96)" : "#eae9f2",
                  }}
                />
                {ErrorPhone && (
                  <div style={style.error}>الرجاء ادخال رقم صحيح</div>
                )}
              </div>

              <div className="mb-4">
                <DobComponent
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  error={ErrorDob}
                />
                {ErrorDob && (
                  <div style={style.error}>الرجاء إدخال تاريخ الميلاد.</div>
                )}
              </div>

              <div className="d-flex justify-content-start">
                <Button
                  variant="primary"
                  size="lg"
                  type="submit"
                  disabled={
                    isSubmitting ||
                    !values.phoneNo ||
                    !values.name ||
                    !selectedDate
                  }
                  style={{
                    borderRadius: "50px",
                    padding: "10px 30px",
                    minWidth: "200px",
                    border: "none",
                  }}
                  className="custom-black-btn"
                >
                  {isSubmitting ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      جاري الإرسال...
                    </>
                  ) : (
                    "تأكيد والاستمرار"
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

const style = {
  error: {
    color: "rgb(253, 62, 96)",
    fontWeight: "normal",
    fontSize: 12,
    direction: "rtl",
    fontFamily: "Cairo",
    marginTop: 4,
    marginBottom: 12,
    textAlign: "right",
  },
};
